import "modern-normalize/modern-normalize.css"
import App from "./App.svelte"
import "./global.css"

const app = new App({ target: document.body })

export default app
